import { createModule } from "../actions/utils";
import { SERVICE_ENDPOINT } from "../apis/constants";


const GetDocSequence = createModule({
  base: 'GET_DOCUMENT_SEQUENCE',
  apiDetails: SERVICE_ENDPOINT.GET_DOCUMENT_SEQUENCE,
  errors: { defaultError: false, customError: '' },
});
const CreateDocSequence = createModule({
  base: 'CREATE_DOCUMENT_SEQUENCE',
  apiDetails: SERVICE_ENDPOINT.CREATE_DOCUMENT_SEQUENCE,
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});
const UpdateDocSequence = createModule({
  base: 'UPDATE_DOCUMENT_SEQUENCE',
  apiDetails: SERVICE_ENDPOINT.UPDATE_DOCUMENT_SEQUENCE,
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});
const MarkAsDefault = createModule({
  base: 'MARK_AS_DEFAULT',
  apiDetails: SERVICE_ENDPOINT.MARK_AS_DEFAULT,
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});
export { GetDocSequence, CreateDocSequence, UpdateDocSequence, MarkAsDefault };
